import { Api } from 'lib/api.mjs';

/** The weekly dashboard payload, and today's live figures. */

/** @param {{ week?: number, signal?: AbortSignal }} [payload] */
export function getDashboard({ week = 0, fresh = false, signal } = {}) {
  // week=0 is meaningful (this week), so it is sent explicitly rather than
  // dropped as an empty value. fresh=1 is the Refresh button: it waits for
  // a new read. A normal open will take a recent copy and refresh behind it.
  const freshQ = fresh ? '&fresh=1' : '';
  return Api.get(`/dashboard?week=${week}${freshQ}`, { signal });
}

/** @param {{ signal?: AbortSignal }} [payload] */
export function getToday({ signal } = {}) {
  return Api.get('/daily/today', { signal });
}

/**
 * Who you are, what is configured, and — the reason the Custom report calls it —
 * EVERY registered ad account, archived ones included.
 *
 * The dashboard payload cannot answer that: its campaign list is this week's
 * live campaigns, so an account that spent last month but has nothing running
 * now would be missing from a filter over last month.
 *
 * @param {{ signal?: AbortSignal }} [payload]
 */
export function getStatus({ signal } = {}) {
  return Api.get('/status', { signal });
}

/** Today's six funnel indicators against the previous calendar day. */
export function getFunnelHealth({ signal } = {}) {
  return Api.get('/funnel-health', { signal });
}
